// extracted by mini-css-extract-plugin
export default {"area_wrapper":"area_wrapper___fId1C"};